<template>
  <div>
    <div class="container-nav px-0 shadow-sm float-left w-100" :class="{'background-light-blue': isRC1, 'bundleflow':flowType === 'bundle'}" v-if="showNavigation()">

          <div v-if="navData.tab_buttons" class="sub-nav sub-nav-rc1 float-left" :class="{ 'hide' : isCurrentFlowRC2('RC1') }">
            <button tabindex="0" v-for="(nData, nKey) in navData.tab_buttons" :key="nKey" v-if="checkTabDispCond('RC1', nData)" :title="`${nData.screenReaderDesc} ${nData.label}`" class="nav-item cursorBox" @keydown.enter.prevent.stop="redirectTo(nData)" @click="redirectTo(nData)"
            v-bind:class="{'': nKey != tab_buttons_last_index, 'activeTab':  nData.status.includes('Active'),
            'disabled':   nData.status === 'Disabled' }" style="height: 100%;">
                  <template v-if="nData.status === 'InactiveComplete' || nData.status === 'ActiveComplete'">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-circle fa-stack-2x icon-complete"></span>
                      <span class="fas fa-check fa-stack-1x" style="color:#fff"></span>
                    </span>
                  </template>
                  <template v-if="nData.status === 'InactiveIncomplete' || nData.status === 'ActiveIncomplete'">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-circle fa-stack-2x icon-incomplete"></span>
                      <span class="fas fa-exclamation fa-stack-1x" style="color:#fff"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='NamedInsured' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-user fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-user fa-stack-2x"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='Vehicles'  && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-car fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-car fa-stack-2x"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='Drivers' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-users fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-users fa-stack-2x"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='PriorInsurance' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-id-card fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-id-card fa-stack-2x"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='NewCoverages' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-list-alt fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-list-alt fa-stack-2x"></span>
                    </span>
                  </template>
                  <template v-if="nData.name=='CarrierMatches' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                    <span class="fa-stack uniform-icon-size">
                      <span class="fas fa-boxes fa-stack-2x" style="visibility: hidden;"></span>
                      <span class="fas fa-boxes fa-stack-2x"></span>
                    </span>
                  </template>
                  <span class="navi-btn-label">{{ nData.label }}</span>
              </button>
            </div>

            <div v-if="navData.tab_buttons" id="sub-nav-rc2" class="sub-nav sub-nav-rc2 float-left" :class="{ 'hide' : isCurrentFlowRC2('RC2') }">
              <button tabindex="0" v-for="(nData, nKey) in navData.tab_buttons" :key="nKey"  v-if="checkTabDispCond('RC2', nData)" :title="`${nData.screenReaderDesc} ${nData.label}`" class="nav-item-rc2 cursorBox" @keydown.enter.prevent.stop="redirectTo(nData)" @click="redirectTo(nData)"
              v-bind:class="{'': nKey != tab_buttons_last_index, 'activeTab2':  nData.status.includes('Active'),
              'disabled2':   nData.status === 'Disabled' }" style="height: 100%;">
                    <template v-if="nData.status === 'InactiveComplete' || nData.status === 'ActiveComplete'">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-circle fa-stack-2x icon-complete"></span>
                        <span class="fas fa-check fa-stack-1x" style="color:#fff"></span>
                      </span>
                    </template>
                    <template v-if="nData.status === 'InactiveIncomplete' || nData.status === 'ActiveIncomplete'">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-circle fa-stack-2x icon-incomplete"></span>
                        <span class="fas fa-exclamation fa-stack-1x" style="color:#fff"></span>
                      </span>
                    </template>
                    <template v-if="nData.name=='ContactDetails' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-folder-plus fa-stack-2x" style="visibility: hidden;"></span>
                        <span class="fas fa-folder-plus fa-stack-2x"></span>
                      </span>
                    </template>
                    <template v-if="nData.name=='DriverVehicleDetails' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-folder-plus fa-stack-2x" style="visibility: hidden;"></span>
                        <span class="fas fa-folder-plus fa-stack-2x"></span>
                      </span>
                    </template>
                    <template v-if="nData.name=='PolicyDetails' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-folder-plus fa-stack-2x" style="visibility: hidden;"></span>
                        <span class="fas fa-folder-plus fa-stack-2x"></span>
                      </span>
                    </template>
                    <template v-if="nData.name=='Checkout' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-shopping-cart fa-stack-2x" style="visibility: hidden;"></span>
                        <span class="fas fa-shopping-cart fa-stack-2x"></span>
                      </span>
                    </template>
                    <template v-if="nData.name=='Confirmation' && (nData.status=='ActiveFirstTime' || nData.status=='InactiveFirstTime' || nData.status=='Disabled')">
                      <span class="fa-stack uniform-icon-size">
                        <span class="fas fa-clipboard-check fa-stack-2x" style="visibility: hidden;"></span>
                        <span class="fas fa-clipboard-check fa-stack-2x"></span>
                      </span>
                    </template>
                    <span class="navi-btn-label">{{ nData.label }}</span>
                </button>
              </div>

    </div>
    <div v-else class="container-nav px-0 shadow-sm float-left w-100 background-light-blue bundleflow blank"></div>
    <Breadcrumbs v-if="flowType==='bundle' || flowType==='cabundle' || flowType==='rabundle'" :navData="navData"></Breadcrumbs>
  </div>
</template>

<script>
/**
 * Navigation.vue is focused on rendering the Navigation Bar for all interview pages.
 * If a particular page is completed, it will be represented by a green check icon.
 * If not, there will be a yellow exclamation icon.
 * The Navigation component utilizes NPM package called Vue Awesome. Vue Awesome abstracts
 * the details of working with font awesome (icons) directly. We simply define a custom
 * HTML element <icon> and whatever icon we specify in name="" attribute will be shown on
 * screen. The icon names remain identical to font awesome documentation.
 */
import commonService from '../../../services/common';
import postData from '../../../services/postData';
import Breadcrumbs from '../../shared/Breadcrumbs';

export default {
  props: ['navData'],
  data() {
    return {
      hasRc2Section: null,
      flowType: '',
    };
  },
  components: {
    Breadcrumbs,
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
  },
  watch: {
    hasRc2Section: (value) => {
      const appContainer = document.getElementById('app-container');

      if (appContainer) {
        appContainer.classList.remove('admin-nav');

        if (value) { // RC2 nav is now visible
          appContainer.classList.add('stacked-nav');
        }
      }
    },
    navData: (val) => {
      const tabBtns = val.tab_buttons;

      tabBtns.forEach((element) => {
        const e = element;
        if (e.status.indexOf('Disabled') !== -1) {
          e.screenReaderDesc = 'Page Disabled';
        } else if (e.status.indexOf('Incomplete') !== -1) {
          e.screenReaderDesc = 'Page Incomplete';
        } else if (e.status.indexOf('Complete') !== -1) {
          e.screenReaderDesc = 'Page Complete';
        } else {
          e.screenReaderDesc = '';
        }
      });
    },
  },
  methods: {
    /* eslint-disable */
    showNavigation() {
      return (this.flowType !== 'bundle' || (this.flowType === 'bundle' && this.$router.currentRoute.path !== '/auto/carrier-matches' && !this.$router.currentRoute.path.includes('/checkout') && !this.$router.currentRoute.path.includes('/confirmation')))
      && (this.flowType !== 'cabundle' || (this.flowType === 'cabundle' && this.$router.currentRoute.path !== '/auto/carrier-matches' && !this.$router.currentRoute.path.includes('/checkout') && !this.$router.currentRoute.path.includes('/confirmation')))
      && (this.flowType !== 'rabundle' || (this.flowType === 'rabundle' && this.$router.currentRoute.path !== '/auto/carrier-matches' && !this.$router.currentRoute.path.includes('/checkout') && !this.$router.currentRoute.path.includes('/confirmation')));        
    },
    isCurrentFlowRC2(flow) {
      let hideNav = false;
      if (this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') {
        let currentFlow = ['/auto/name-insured', '/auto/vehicles', '/auto/drivers', '/auto/prior-insurance', '/auto/coverage'].includes(this.$router.currentRoute.path) ? 'RC1' : 'RC2';
        if (currentFlow === flow) {
          hideNav = false;
        } else {
          hideNav = true;
        }
      }
      return hideNav;
    },
    checkTabDispCond(flow, nData) {
      // const currentNav = sessionStorage.getItem('currentNav');
      if (flow === 'RC1') {
        return (nData.section !== 'RC2' && !((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && nData.name === 'CarrierMatches'));// && (currentNav !== 'homerc1' && currentNav !== 'autorc2')));
      } else if (flow === 'RC2') {
        return (this.isRc2(nData.section) && !((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && (nData.name === 'Checkout' || nData.name === 'Confirmation')));// && (currentNav !== 'homerc1' && currentNav !== 'autorc2')));
      }
      return false;
    },
    isRc2(section) {
      if (section === 'RC2') { // TODO: Use less LOC
        this.hasRc2Section = true;
        return true;
      }

      this.hasRc2Section = false;
      return false;
    },
    redirectTo(nData) {
      /*
      * set page load start time in store
      */
      this.$store.dispatch('setStartTime');
      const currentNavLink = this.$store.getters.getNavLink;

      if (nData.status !== 'Disabled') {
        const formData = commonService.getFormData(this.navData);
        const requestParams = {
          url: nData.on_click,
          data: formData,
        };
        postData.navigationFormPost(requestParams).then((response) => {
          if (response.data.Navigate) {
            // Reload the page if the from and to routes are the same so that it gets new page data.
            if (response.data.Navigate.toLowerCase() === currentNavLink.toLowerCase()) {
              this.$router.go(commonService.getRouteName(response.data.Navigate)); // TODO Fetch the page data, don't reload
            }

            this.$store.dispatch('setCurrentNav', response.data.Navigate);
            this.$router.replace(commonService.getRouteName(response.data.Navigate));
          }
        });
      }
    },
  },
  computed: {
    /**
     * The tab buttons are received async, so it needs a
     * default value until the property exists.
     */
    tab_buttons_last_index() {
      return (typeof this.navData.tab_buttons !== 'undefined' ?
        (this.navData.tab_buttons.length - 1) : null);
    },
    isRC1() {
      if (this.navData.tab_buttons && this.navData.tab_buttons.length < 7) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
  .background-light-blue {
    background: $var-color-nav-auto-bg !important;
    &.bundleflow {
      background: $var-home-auto-bundle-bg !important;//TODO
      &.blank {
        height: 34px;
      }
    }
  }

  .uniform-icon-size {
    font-size: .75rem;
  }

  div.container-nav {
    color: #ffffff;
    background: #FFFFFF;
  }

  .sub-nav{
    display: inline-flex;
    font-size: 0.625rem;
    &.hide {
      display: none;
    }
  }

    .sub-nav-rc2 {
      background:#FFFFFF;
    }

  .sub-nav .nav-item,
  .sub-nav .nav-item-rc2 {
    padding: 0.75em 1.5em;
    border: none;
  }

  .sub-nav .nav-item {
    display: inline-block;
    background: $var-color-nav-auto-bg;
    color: $var-color-header-auto-icon;
  }

  .sub-nav .nav-item-rc2 {
    background: #FFFFFF;
    color: $var-color-header-auto;
  }

  .sub-nav .activeTab,
  .sub-nav .activeTab2,
  .sub-nav .nav-item:hover{
    background: $var-color-header-auto;
    color: #fff;
  }

  .sub-nav .nav-item-rc2:hover{
    background: $var-color-header-auto;
    color: #FFFFFF !important;
  }

  .sub-nav .nav-item.disabled:hover,
  .sub-nav .nav-item-rc2.disabled2:hover{
    background: none !important;
    cursor: default !important;
  }
  .sub-nav .activeTab2 {
    color: #fff;
  }
  .bundleflow {
    .sub-nav .nav-item {
      background: $var-home-auto-bundle-bg;
      color: $var-color-home-auto-bundle-icon;
    }

    .sub-nav .nav-item-rc2 {
      color: $var-color-header-auto;//TODO:Check in RC2
    }

    .sub-nav .activeTab,
    .sub-nav .activeTab2,
    .sub-nav .nav-item:hover{
      background: $var-color-home-auto-bundle;
      color: #fff;
    }

    .sub-nav .nav-item-rc2:hover{
      background: $var-color-home-auto-bundle;
    }
  }

  /***fontawesome stack-2x overide***/
  .fa-stack{
    height: 1.625em;
    width: 2.0em;
    line-height: 1.625em;
  }
    .fa-stack-2x{
      font-size: 1.5em;
    }

  span.navi-btn-label {
    position: relative;
    margin-left: 2px;
    display: inline-block;
  }

  button.disabled,
  button.disabled2{
    cursor: default;
  }

  .sub-nav .disabled i,
  .sub-nav .disabled span.navi-btn-label {
    color: $var-color-icon-disabled;
  }

  .sub-nav .disabled2 i,
  .sub-nav .disabled2 span,
  .sub-nav .disabled2 span.navi-btn-label {
    color: $var-color-icon-disabled;
  }

  /***navigation breakpoints***/
  @media all and (max-width: 1372px) {
    .sub-nav-rc1, .sub-nav-rc2 {
      width: 100%;
    }
  }
  @media all and (min-width: 1371px) {
    .container-nav {
      background: FFFFFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/Navigation.vue?440e5d54